
import Axios from 'axios';
import { SubmissionRequestModel, GetColumnConfigPayload, LoadFormPayload, SubmissionRequestPayload} from './models/SubmissionModel';
// import {getEncryptedString} from './crypto';

const config = require(`${__dirname}/config.${process.env.NODE_ENV}.json`);
const uiHubAxios = Axios.create();
Axios.interceptors.request.use((axiosConfig:any) => {
    const token = getCookieValue('authToken');
    const userId = getCookieValue('userId');
    axiosConfig.headers.Accept =  'text/html, application/json';
    axiosConfig.headers.Authorization = `Bearer ${token}`;
    axiosConfig.headers.userId = userId;
    axiosConfig.headers.userRole = getUserRole();
    return axiosConfig;
});

uiHubAxios.interceptors.request.use((axiosConfig:any) => {
    const token = getCookieValue('authToken');
    const userId = getCookieValue('userId');
    const tanantId = getCookieValue('ui-hub-tenantId');
    axiosConfig.headers.Accept = 'text/html, application/json';
    axiosConfig.headers.Authorization = `Bearer ${token}`;
    axiosConfig.headers['X-TenantId'] = tanantId;
    axiosConfig.headers.userId = userId;
    axiosConfig.headers.userRole = getUserRole();
    return axiosConfig;
});

export const getCookieValue = (a: string) : string => {
    const b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() || '' : '';
}

export const getUserRole = () => {
    return getCookieValue('userRole').split('/').join(',');
}

export interface LoadAppMessageService {
    loadFormDataService: (data: LoadFormPayload) => Promise<any>;
    saveFormDataService: (data: SubmissionRequestPayload) => Promise<any>;
    updateFormDataService: (data: any) => Promise<any>;
    getSubmissions: (data: SubmissionRequestModel) => Promise<any>;
    deleteSubmission: (data: any) => Promise<any>;
    getConfigurations: (data: any) => Promise<any>;
    getColumnConfig: (data:GetColumnConfigPayload) => Promise<any>;
    getData: (url:string, data: any) => Promise<any>;
}

const ApplicationDataService: Service = {

    saveFormDataService: (data: SubmissionRequestPayload) => {
        return Axios.post(data.submissionUrl || `${config.appBaseUrl}/${data.formAlias}`, data.formData && data.formData.data)
        .then(response => {
           return response && response.data ? response.data : response;
        });
    },
    updateFormDataService: (data: any) => {
        return Axios.put(data.loadFormData.submissionUrl || `${config.appBaseUrl}/${data.loadFormData.formAlias}`, data.payload)
        .then(response => response.data);
    },
    getSubmissions: (data: SubmissionRequestModel) => {
        const url = data.remoteDataUrl || `${config.appBaseUrl}/${data.listAlias}/list}`;
        let queryString = '?pageSize=' + data.itemsPerPage
        queryString += '&pageNum=' + data.pageNumber
        queryString += data.query.orderDirection ? '&orderdir=' + data.query.orderDirection : ''
        data.query.filters.forEach((filter:any) => {
            if (!filter.value || (filter.value && filter.value.length===0)){
                return;
            }
            queryString += '&filter[' + filter.column.field + ']=' + filter.value
        });
        if (data.query.orderBy !== undefined){
            queryString += '&orderby=' + data.query.orderBy.field;
        }
        if (data.query.search.length > 0) {
            queryString += '&search=' + data.query.search
        }
        return Axios
            .get(`${url}${queryString || ''}${data.stringParams || ''}`)
            .then(result => ({
                data: result.data.data,
                page: (result.data.pageRequest.pageNum || 1) - 1,
                totalCount: result.data.totalNoOfRecords,
            })
            ).catch((_error) => {
                return {
                    data: [],
                    page: 0,
                    totalCount: 0,
                }
            });
    },
    deleteSubmission: (data: any) => {
        return Axios.delete(`${config.appBaseUrl}/${data.gridData.formAlias}`, { data: data.dataToBeDeleted})
        .then(response => response.data);
    },
    getConfigurations: (data: any) => {
        return Axios.get(`${config.appBaseUrl}/appConfig/list?pageNum=1&pageSize=100`, { data }).then(response => response.data);
    },
    loadFormDataService: (data: LoadFormPayload) => {
        return uiHubAxios.get(`${config.uiHubBaseUrl}/dynamicform/${data.formAlias}?version=${data.version || ''}`)
        .then(response => response.data);
    },
    getColumnConfig: (data: GetColumnConfigPayload) => {
    return (
        uiHubAxios.get(`${config.uiHubBaseUrl}/listColumn/${data.listAlias}`)
        .then(response => response.data)
        );
    },
    getData: (url:string, searchData: any) => {
        return Axios
            .post(`${url}`, searchData)
            .then(result => {
                return {
                    data: result.data.data,
                    page: (result.data.pageRequest.pageNum || 1) - 1,
                    totalCount: result.data.totalNoOfRecords,
                }
            }).catch((error) => {
                if (error.response && error.response.status === 401) {
                    window.location.href = config.pingfedUrl;
                }
                return {
                    data: [],
                    page: 0,
                    totalCount: 0,
                }
            });
    }

}

export type Service = LoadAppMessageService;

export default ApplicationDataService;
